import React from 'react';
import { Link } from 'react-router-dom';
import QuestionActivityItem from './QuestionActivityItem';
import ReplyActivityItem from './ReplyActivityItem';

/**
 * RecentActivityList component for displaying chronologically sorted forum activities
 * Renders questions and replies in a unified activity feed
 */
const RecentActivityList = React.memo(({ activities, totalActivity }) => {
  if (!activities || activities.length === 0) {
    return null;
  }

  return (
    <div>
      <h3 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">
        Recent Activity
      </h3>
      
      <div className="space-y-3">
        {activities.map((activity) => (
          <div key={`${activity.type}-${activity.id}`}>
            {activity.type === 'question' ? (
              <QuestionActivityItem question={activity} />
            ) : (
              <ReplyActivityItem reply={activity} />
            )}
          </div>
        ))}
      </div>

      {/* Show "View all activity" link if there are more activities */}
      {totalActivity > activities.length && (
        <div className="mt-4 text-center">
          <Link
            to="/forum"
            className="text-sm text-purple-600 hover:text-purple-700 dark:text-purple-400 dark:hover:text-purple-300 font-medium transition-colors duration-200"
          >
            View all activity →
          </Link>
        </div>
      )}
    </div>
  );
});

RecentActivityList.displayName = 'RecentActivityList';

export default RecentActivityList;